import { companyActions } from "../../actionTypes";

const initialState = {
	company: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case companyActions.CREATE_COMPANY: {
			return { ...state, fetching: true };
		}

		case companyActions.CREATE_COMPANY_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				company: action.payload,
			};
		}

		case companyActions.CREATE_COMPANY_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
